module.exports = __webpack_public_path__ + "img/kv.9406fbaa.png";